import { getCorridorBySlug } from "@/data/corridors/registry";
import { isReversePublicCorridorSlug, resolveCorridorSlug } from "@/data/corridors/corridorSeoSlugs";

function truncateForMeta(text: string, maxLen = 158): string {
  if (text.length <= maxLen) return text;
  const sliced = text.slice(0, maxLen);
  const lastSpace = sliced.lastIndexOf(" ");
  return `${(lastSpace > 100 ? sliced.slice(0, lastSpace) : sliced).trim()}…`;
}

export function getCorridorPageSeo(publicSlug: string): { title: string; description: string } | undefined {
  const internal = resolveCorridorSlug(publicSlug);
  const corridor = getCorridorBySlug(internal);
  if (!corridor) return undefined;

  const reverse = isReversePublicCorridorSlug(publicSlug);
  const from = reverse ? corridor.cityB : corridor.cityA;
  const to = reverse ? corridor.cityA : corridor.cityB;
  const { stats, routeGuide } = corridor;

  const description = routeGuide
    ? truncateForMeta(routeGuide.overview)
    : `Book or offer ${from} to ${to} carpool rides on Duri. Travel comfortably, split costs, and connect with verified riders and hosts on ${stats.highway}.`;

  return {
    title: `${from} to ${to} Carpool | Verified Rides on Duri`,
    description,
  };
}
